export default {
      id: "Icon--map-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--map",
      toString: function () {
        return this.url;
      }
    }